import { render, staticRenderFns } from "./PurchasesOrderViewDetailsPurchasesOrderItemForm.vue?vue&type=template&id=1e1706f9"
import script from "./PurchasesOrderViewDetailsPurchasesOrderItemForm.vue?vue&type=script&lang=js"
export * from "./PurchasesOrderViewDetailsPurchasesOrderItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports